import React from "react";
import style from "../../Styles/Components/ProductBanner.module.css";
import Logo from "../../Components/Logo";

import ImageSwiper from "../ImageSwiper";

const ProductBanner = ({ imgUrl, imageUrlList, description, code, layoutIndex, imgCustomStyle }) => (


  <div className={style.container}>
      { [1,2,3,4].indexOf(layoutIndex) > -1 ? <Logo imgSrc={imgUrl}/> : null }
      {
          code ?
              (
                  <div className={style.codeContainer}>
                      <div className={style.codeTag}>
                          <span className={style.textBold}>{description}</span>
                          <span>•</span>
                          <span>{code}</span>
                      </div>
                  </div>
              ) : null
      }
    <ImageSwiper customStyle={imgCustomStyle} imageUrlList = {imageUrlList}/>
  </div>
);

export default ProductBanner;
